import React, { useMemo, useState } from 'react';
import { LibraryItem } from '../../../../entities/LibraryItem';
import { SortableTableHeader, TableHeader, TableSortOrder } from '../../../../components/SortableTableHeader';
import { orderBy, SortDirection } from '../../../../utilities/orderBy';
import { printLibraryItemType } from '../../../../entities/LibraryItemType';
import { printAssetCategory } from '../../../../entities/AssetCategory';
import { DesktopLibraryTableRow } from './DesktopLibraryTableRow';
import { SortCatagories } from './SortByDropDown';
import { Table, TableBody } from '@material-ui/core';

interface Props {
    items: LibraryItem[]
    focusedItem?: LibraryItem;
    sortBy: SortCatagories;
    setFocusedItem: (id:string) => void;
}

function sortItems(sortOrder: TableSortOrder, sortProperty: SortCatagories): (a: LibraryItem, b: LibraryItem) => number {
    const sortDirection: SortDirection = sortOrder === "asc" ? "Ascending" : "Descending";
    switch(sortProperty){
        case ('Name'):
            return orderBy.string((i) => i.name, sortDirection);
        case ('Type'):
            return orderBy.string((i) => i.category ? printAssetCategory(i.category) : printLibraryItemType(i.type) , sortDirection);
        case ('Created Date'):
            return orderBy.date((i) => i.dateCreated, sortDirection);
        case ('Last Modified'):
            return orderBy.date((i) => i.dateModified, sortDirection);
        case ('Last Opened'):
            return orderBy.date((i) => i.dateAccessed, sortDirection);
        case ('Preach Date'):
            return orderBy.optional.date((i) => i.datePreached, sortDirection, "optionalEnd");
        case ('Location'):
            return orderBy.optional.string((i) => i.locationPreached, sortDirection, "optionalEnd");
        default:
            return () => 0;
    }
}

export function DesktopLibraryAssetTable(props: Props) {
    const { sortBy } = props;
    const [sortDirection, setSortDirection] = useState<TableSortOrder>("desc");
    const [sortProperty, setSortProperty] = useState<SortCatagories>(sortBy)
    
    useMemo(() => {
        setSortProperty(props.sortBy);
        setSortDirection("desc");
    }, [props.sortBy]);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const changeColumnName = useMemo(() => sortBy !== "Name" && sortBy !== "Type", [props.sortBy]);
    const orderedItems = useMemo(() => [...props.items].sort(sortItems(sortDirection, sortProperty)), [props.items, sortDirection, sortProperty])
    
    const sortTable = (property:string, direction:TableSortOrder) => {
        setSortDirection(direction);
        setSortProperty(property as SortCatagories);
    };

    return (
        <Table>
            <SortableTableHeader order={sortDirection} orderBy={sortProperty} >
                <TableHeader property='Name' onSort={sortTable}>
                    Name
                </TableHeader>
                <TableHeader property='Type' onSort={sortTable}>
                    Type
                </TableHeader>
                <TableHeader property={sortBy.toString()} onSort={sortTable}>
                    {changeColumnName ? sortBy : "Date Modified"}
                </TableHeader>
            </SortableTableHeader>
            <TableBody>
                { orderedItems.map((item) => 
                    <DesktopLibraryTableRow key={item.id} item={item} sortBy={sortBy} setFocusedItem={props.setFocusedItem} focusedItemId={props.focusedItem?.id}/>
                )}
            </TableBody>
        </Table>
    )
}